<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            color="primary"
            x-small
            text
            @click="() => $router.push({ name: 'matriculas' })"
            :disabled="submittingForm"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          {{ editing ? "Editando" : "Criando" }} Matrícula
        </h1>
      </v-col>
    </v-row>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submitForm)" :disabled="submittingForm">
        <v-row v-for="matricula of form.matriculas" :key="form.matriculas.indexOf(matricula)">
          <v-col class="pt-0 pb-0" cols="6">
            <e-label>Aluno</e-label>
            <e-autocomplete
              :items="getAlunosFiltrados(matricula)"
              :return-object="false"
              :item-value="(aluno) => aluno.id"
              :item-text="(aluno) => aluno.nomecompleto"
              :loading="carregandoAlunos"
              :readonly="editing"
              v-model="matricula.aluno_id"
              label="Selecione uma opção"
              dense
              solo
              :disabled="editing || alunosList.length === 0"
              @change="(alunoId) => verificarSeAlunoPossuiMatriculaNoMunicipio(matricula)"
            />
          </v-col>

          <v-col class="pt-0 pb-0" cols="6">
            <e-label>Turma</e-label>
            <!-- Modo Criação: permite seleção -->
            <e-autocomplete
              v-if="!editing"
              :items="turmasList"
              :return-object="true"
              :item-text="(turma) => turma.descricao"
              :loading="carregandoTurmas"
              v-model="matricula.turma"
              @change="(turma) => changeTurma(matricula, turma)"
              label="Selecione uma opção"
              dense
              solo
              :disabled="turmasList.length === 0"
            />
            <!-- Modo Edição: exibe turma como somente leitura -->
            <v-text-field
              v-else
              :value="matricula.turma ? matricula.turma.descricao : ''"
              readonly
              dense
              solo
              filled
              disabled
            />
          </v-col>
          <v-col class="pt-0 pb-0" cols="6">
            <e-label>Série</e-label>
            <!-- Modo Criação: permite seleção -->
            <e-autocomplete
              v-if="!editing"
              :items="matricula.turma ? matricula.turma.series : []"
              :return-object="false"
              :item-value="(serie) => serie.id"
              :item-text="(serie) => serie.descricao"
              :disabled="!matricula.turma"
              v-model="matricula.serie_id"
              label="Selecione uma opção"
              dense
              solo
            />
            <!-- Modo Edição: exibe série como somente leitura -->
            <v-text-field v-else :value="getSerieDescricao(matricula)" readonly dense solo filled />
          </v-col>
          <v-col class="pt-0 pb-0" cols="6">
            <e-label>Data da Matrícula</e-label>
            <v-menu
              v-model="matricula.menuDataMatricula"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="formatarDataBr(matricula.data_matricula)"
                  placeholder="dd/mm/yyyy"
                  append-icon="fa fa-calendar-alt"
                  readonly
                  dense
                  solo
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="matricula.data_matricula"
                no-title
                locale="pt-BR"
                @input="matricula.menuDataMatricula = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col class="pt-0 pb-0" cols="12">
            <e-label>Transporte Escolar Público</e-label>
            <v-switch
              v-model="matricula.utiliza_transporte_publico"
              :label="matricula.utiliza_transporte_publico ? 'Utiliza' : 'Não Utiliza'"
              class="mt-0"
              inset
            />
          </v-col>
          <v-col v-if="form.matriculas.length > 1" class="pt-0 pb-0 d-flex justify-end" cols="12">
            <v-btn
              color="error"
              @click="
                () =>
                  (form.matriculas = form.matriculas.filter(
                    (matriculaObj) => matriculaObj !== matricula
                  ))
              "
              small
              ><v-icon small>fa-trash</v-icon></v-btn
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <div class="d-flex">
              <v-btn
                color="primary"
                :disabled="submittingForm"
                :loading="submittingForm"
                type="submit"
                >Enviar Dados</v-btn
              >
              <v-btn class="ml-3" v-if="!editing" color="secondary" @click="adicionarMatricula">
                Adicionar
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </form>
    </ValidationObserver>

    <e-sheet-aviso-matricula-existente
      :sheet="sheet"
      :matricula="matricula"
      @changeSheet="sheet = $event"
    ></e-sheet-aviso-matricula-existente>
  </main-template>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ESheetAvisoMatriculaExistente from "../../components/Matriculas/ESheetAvisoMatriculaExistente.vue";
import ELabel from "../../components/ELabel.vue";

export default {
  components: {
    ELabel,
    ESheetAvisoMatriculaExistente,
  },
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters("Matriculas", ["matriculas", "matriculasList", "carregandoMatriculas"]),
    // ...mapGetters("Alunos", ["carregandoAlunos"]),
    ...mapGetters("Turmas", ["turmasList", "carregandoTurmas"]),
  },
  mounted() {
    this.loadData();
    // this.loadFormData();
  },
  data() {
    return {
      submittingForm: false,
      form: { matriculas: [{ menuDataMatricula: false }] },
      series: [],
      alunosList: [],
      carregandoAlunos: false,
      disabled: true,
      sheet: false,
      matricula: {},
    };
  },
  methods: {
    // ...mapActions("Matriculas", ["loadMatriculas"]),
    // ...mapActions("Alunos", ["loadAlunos"]),
    ...mapActions("Turmas", ["loadTurmas"]),
    changeTurma(matricula, turma) {
      matricula.turma_id = turma.id;
      matricula.serie_id = turma.series[0].id;
    },

    getSerieDescricao(matricula) {
      // Preferir o campo já resolvido pelo backend (fonte única de verdade).
      if (matricula.serie_de_exibicao) return matricula.serie_de_exibicao;

      // Fallback client-side replicando a mesma semântica do accessor do backend:
      // se a turma tiver exatamente 1 série vinculada, usar essa série;
      // caso contrário (0 ou >1 séries), usar a série bruta da matrícula.
      if (
        matricula.turma &&
        Array.isArray(matricula.turma.series) &&
        matricula.turma.series.length === 1
      ) {
        return matricula.turma.series[0].descricao || "";
      }
      return matricula.serie ? matricula.serie.descricao : "";
    },

    adicionarMatricula() {
      this.form.matriculas.push({ menuDataMatricula: false });
    },

    formatarDataBr(dataMatricula) {
      if (!dataMatricula) return "";
      const dataIso = String(dataMatricula).substring(0, 10);
      if (!dataIso.match(/\d{4}-\d{2}-\d{2}/)) return "";
      const [ano, mes, dia] = dataIso.split("-");
      return `${dia}/${mes}/${ano}`;
    },

    async verificarSeAlunoUtilizaTransportePublico(alunoId) {
      try {
        const aluno = await this.$services.alunosService.pegarAluno(alunoId);
        return aluno.utiliza_transporte_publico;
      } catch (error) {
        this.$handleError(error);
        return false;
      }
    },

    async verificarSeAlunoPossuiMatriculaNoMunicipio(matricula) {
      try {
        await this.$services.matriculasService
          .verificarSeAlunoPossuiMatriculaNoMunicipio(matricula)
          .then(async (response) => {
            if (response === "") {
              this.sheet = false;
              this.disabled = false;

              // Verificar se o aluno utiliza transporte público
              const utilizaTransportePublico = await this.verificarSeAlunoUtilizaTransportePublico(
                matricula.aluno_id
              );
              matricula.utiliza_transporte_publico = utilizaTransportePublico;
            } else {
              this.form.matriculas = this.form.matriculas.filter(
                (matriculaObj) => matriculaObj.aluno_id !== matricula
              );
              this.matricula = response;
              this.sheet = true;
              this.disabled = true;
            }
          })
          .catch(() => {
            this.disabled = true;
          });
      } catch (error) {
        this.$handleError(error);
      }
    },
    async submitForm() {
      this.form.especial = Boolean(this.form.especial);
      this.form.recursos_saeb = this.recursos_saeb;
      this.submittingForm = true;
      try {
        if (this.editing) {
          await this.$services.matriculasService.atualizarMatricula(this.form.matriculas[0]);
        } else {
          await this.$services.matriculasService.matricular(this.form);
        }
        this.$toast.success("Matricula Atualizada com sucesso");
        this.$router.push({ name: "matriculas" });
      } catch (error) {
        this.$handleError(error);
      }
      this.submittingForm = false;
    },
    async loadAlunos() {
      this.carregandoAlunos = true;
      try {
        this.alunosList = await this.$services.alunosService.syncAll();
      } catch (error) {
        this.$handleError(error);
      }
      this.carregandoAlunos = false;
    },
    async loadData() {
      try {
        if (this.alunosList.length === 0 || this.turmasList.length === 0) {
          this.$loaderService.open("Carregando dados");
        }
        await this.loadFormData();

        await Promise.all([this.loadTurmas()]);
        this.$loaderService.close();
        this.$forceUpdate();
        this.loadAlunos();
        this.loadFormData();
      } catch (error) {
        this.$handleError(error);
      }
    },
    async loadFormData() {
      if (!this.matriculas || !this.editing) {
        this.form = { matriculas: [{ menuDataMatricula: false }] };
        return;
      }
      const { matricula_id } = this.$route.params;
      const matricula = await this.$services.matriculasService.pegarMatricula(matricula_id);
      if (matricula) {
        matricula.data_matricula = matricula.data_matricula
          ? String(matricula.data_matricula).substring(0, 10)
          : null;
        matricula.menuDataMatricula = false;
        this.form = { matriculas: [matricula] };
      }
    },
    getAlunosFiltrados(matricula) {
      const alunosJaSelecionadosIds = this.form.matriculas
        .map((m) => m.aluno_id)
        .filter((id) => id !== null && id !== undefined && id !== "");

      return this.alunosList.filter((a) => {
        if (matricula.aluno_id && a.id === matricula.aluno_id) return true;
        return !alunosJaSelecionadosIds.includes(a.id);
      });
    },
  },
};
</script>

<style></style>
